import { captureMessage } from '../../../../../sentry';
import { automationNewCopy } from './newCopy/automation';
import { ccNewCopy } from './newCopy/cc';
import { instanceSubtaskNewCopy } from './newCopy/instanceSubtask';
import { fallbackCopy, miscNewCopy } from './newCopy/misc';
import { sentItemNewCopy } from './newCopy/sentItem';
import { CopyPack, IssueKind } from './types';

// Each family declares its entries with `satisfies`, so the merged object's
// keys are known and a kind with no entry is a type error here.
const merged: CopyPack = {
  ...automationNewCopy,
  ...sentItemNewCopy,
  ...instanceSubtaskNewCopy,
  ...ccNewCopy,
  ...miscNewCopy
};

// A build can still ship with a gap (the CI typecheck gate only fails on
// TS2304). Fail loudly outside production so a developer sees it at once.
// In production, report the gap as soon as the module loads, so it's known
// before any admin happens to hit the missing kind; `copyFor` then renders
// the unknown-error copy for it.
const missingKinds = (Object.values(IssueKind) as IssueKind[]).filter((kind) => !merged[kind]);
if (missingKinds.length) {
  const message = `newCopy.ts is missing entries for IssueKind(s): ${missingKinds.join(', ')}`;
  if (process.env.NODE_ENV !== 'production') throw new Error(message);
  captureMessage(message, 'error');
}

/** The copy entry for a kind: the only way to read the pack, so a kind with
 * no entry renders the unknown-error copy instead of crashing the view. */
export const copyFor = (kind: IssueKind): CopyPack[IssueKind] => merged[kind] ?? fallbackCopy;
